import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 20.5h14m-14-8h14m-14-8h5M16.5 3l2.625 2.5L23.5.5m-19 2h-4v4h4v-4zm0 8h-4v4h4v-4zm0 8h-4v4h4v-4z" stroke="#000" fill="none" fillRule="evenodd" /></svg>;